export default __webpack_public_path__ + "static/media/clients_xl.232e013d.jpg";